<template>
  <Card
      title="Integrations Info"
      direction="column"
      color="background"
      background="black"
  >
    <TextComponent color="background" type="paragraph" as="p">
      Discord Link Status: {{ (data.discord || {}).discordID ? "Linked" : "Unlinked"}}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Discord OAuth2 Link Status: {{ discordOAuthLinkActive ? "Linked" : "Unlinked"}}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Discord OAuth2 Last Sync Status: {{ (data.discord || {}).lastSyncStatus || "NONE"}}
    </TextComponent>
    <TextComponent color="background" type="paragraph" as="p">
      Discord OAuth2 Last Sync Time: {{ date((data.discord || {}).lastSyncTime || 0)}}
    </TextComponent>
    <Stack
    direction="row">
      <Button v-if="discordOAuthLinkActive" :icon="{ left: `info` }" @click="getMetadata">Get Discord Metadata</Button>
      <Button v-if="discordOAuthLinkActive" :icon="{ left: `unlink` }" @click="removeDiscord">Remove Discord Link</Button>
    </Stack>
    <Stack
    direction="row">
      <Button @click="showCheckInQr" :icon="{ left: `qrcode` }">Show Check In QR</Button>
    </Stack>

  </Card>
</template>

<script>
import Stack from '@hackthe6ix/vue-ui/Stack';
import Button from '@hackthe6ix/vue-ui/Button';
import TextComponent from '@hackthe6ix/vue-ui/Text';
import Card from '../../../../containers/Card';

import 'vue-awesome/icons/info';
import 'vue-awesome/icons/unlink';
import 'vue-awesome/icons/qrcode';
import swal from "sweetalert";
import {disassociateDiscord, editObject, getDiscordMetadata, multiCheckInQR, syncMailingLists} from "@/utils/api";


const format = new Intl.DateTimeFormat(`en`, {
  minute: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  day: 'numeric',
  month: 'short',
}).format;

export default {
  name: 'SocialLinkInfo',
  components: {
    TextComponent,
    Stack,
    Card,
    Button
  },
  methods: {
    date(_) {
      return _ ? format(new Date(parseInt(_))) : 'N/A';
    },
    getMetadata() {
      getDiscordMetadata(this.data._id).then((result) => {
        if(result.success) {
          swal('Discord Metadata', JSON.stringify(result.data));
        }
        else {
          swal('Error', result.data, 'error');
        }
      });
    },
    removeDiscord() {
      swal({
        title: 'CONFIRM ACTION',
        text: 'Are you sure you disassociate the Discord account linked to this user? This action cannot be undone!',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (confirm) => {
        if (confirm) {
          const result = await disassociateDiscord(this.data._id)

          if (result.success) {
            swal('Success', result.data.toString(),
                'success');
          } else {
            swal('Error', result.data, 'error');
          }
        }
      });
    },
    async showCheckInQr() {
      const qrCodeInfo = await multiCheckInQR([{
        userID: this.data._id,
        userType: "User"
      }]);

      const wrapper = document.createElement('div');
      const qrImage = document.createElement('img');
      qrImage.src = qrCodeInfo.data[0].code;

      wrapper.appendChild(qrImage);

      swal({
        text: "Successfully generated QR code",
        content: wrapper
      })
    }
  },
  props: {
    data: Object,
  },
  computed: {
    discordOAuthLinkActive() {
      return !!((this.data.discord || {}).refreshToken)
    }
  }
};
</script>
